import { Dict } from "app/utils/Dict";
import { useEffect, useRef, useState } from "react";
import { Breadcrumb2Container } from "../breadcrumb2/Breadcrumb2Container";
import React from "react";
import { Cashback, DadosCashback } from "./Cashback";
import { IOrcamento } from "app/types/IOrcamento";
import { useAppSelector } from "app/redux/hooks";
import microuniversoApi from "app/api/microuniversoApi";
import globalMU from "globalMU";
import { tratamentoErroPadrao } from "app/use-cases";

type CashbackContainerProps = {
    codigoCliente: number
    onVoltar: () => void;
    passos: Dict<string, () => void>;
    onRemover: () => boolean
}



export const CashbackContainer = (props: CashbackContainerProps) => {
    const orcamento: IOrcamento = useAppSelector((store) => store.orcamento)

    const [dadosCashback, setDadosCashback] = useState<Partial<DadosCashback>>()
    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))


    const onObterDadosCashbackCliente = async () => {
        try {
            globalMU.blockUI();
            const resposta = await microuniversoApi.Cliente.ObterDadosCashbackCliente(props.codigoCliente);
            if (!("HasErrors" in resposta)) {
                setDadosCashback(resposta)
            }
            if (resposta.Saldo == 0 && resposta.NomeCliente == null) {
                globalMU.showWarnMessage("Nenhum registro encontrado")
                onVoltar()
            }
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }

    useEffect(() => {
        passosInterno.current.set("Cashback", () => { })
        onObterDadosCashbackCliente();
    }, [])

    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        passosInterno.current.get(passo)()
    }

    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
    }


    return (
        <>

            <Breadcrumb2Container
                passos={passosInterno.current.keysToList()}
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                onBotaoVoltarClicado={onVoltar}
                onPassoSelecionado={onPassoSelecionado}
                id="CashbackBreadcrumb"
            />

            <Cashback DadosCashback={dadosCashback} />
        </>
    )
}